import MEGAPHONE from '../../types/megaphone'
import { getMegaphoneByProductId, convertPositionToPercent } from './shared'

export default {
  [MEGAPHONE.GETTERS.GET_PRODUCT]: ({products}) => (productId) => {
    return getMegaphoneByProductId(products, productId)
  },
  [MEGAPHONE.GETTERS.GET_MODAL_PARAMS]: (state) => {
    return state.modal
  },
  [MEGAPHONE.GETTERS.GET_BOOST_ACTION_ERROR]: (state) => {
    return state.boostActionError
  },
  [MEGAPHONE.GETTERS.GET_POSITION_RATE]: ({products}) => (productId) => {
    const { positionPercent, position } = getMegaphoneByProductId(products, productId)

    return positionPercent || convertPositionToPercent(position)
  },
  [MEGAPHONE.GETTERS.GET_CAN_BOOST]: ({products}) => (productId) => {
    const { delay, exposure } = getMegaphoneByProductId(products, productId)

    return !!(delay === 0 && exposure)
  },
  [MEGAPHONE.GETTERS.GET_MODAL_IS_OPENED]: ({modal}) => {
    return modal.isOpened
  },
  [MEGAPHONE.GETTERS.GET_STATS]: (state) => {
    return state.enabled
  }
}
